export const EVENT_BOOKING_REGISTER_ENDPOINT = '/account/EventBooking';
